module.exports = __webpack_public_path__ + "img/medal-bronze.dfdc0dc2.svg";